
/**
 * @description ������̨�Զ������ɫ
 * @author cc
 * @data 2020-3-5
 * @export {LoginBtnColor ThemeColor ThemeFontColor colorOpaction} {��¼��ť��ɫ  App������ɫ App������ɫ App������ɫopaction 50% App������ɫopaction 20%}
 */
export const theme = (LoginBtnColor, ThemeColor, ThemeFontColor, colorOpacity5, colorOpacity1, colorOpacity3,colorOpacity7) => {
  const { style } = document.body
  style.setProperty('--APP_login_btn_color', LoginBtnColor)
  style.setProperty('--APP_theme_color', ThemeColor)
  style.setProperty('--APP_theme_font_color', ThemeFontColor)
  style.setProperty('--APP_theme_color_colorOpacity5', colorOpacity5)
  style.setProperty('--APP_theme_color_colorOpacity1', colorOpacity1)
  style.setProperty('--APP_theme_color_colorOpacity3', colorOpacity3)
  style.setProperty('--APP_theme_color_colorOpacity7', colorOpacity7)

}
/**
 * @description ��������������ṩ��jsʹ��
 * @description txw
 */
export const getTheme = () => {
  const { style } = document.body
  return {
    APP_login_btn_color: style.getPropertyValue('--APP_login_btn_color'),
    APP_theme_color: style.getPropertyValue('--APP_theme_color'),
    APP_theme_font_color: style.getPropertyValue('--APP_theme_font_color')
  }
}
/**
 * @description ��16���Ƶ���ɫתΪrgba��ʽ������͸����
 * @author cc
 * @data 2020-3-5
 * @export {_color _opacity} {16������ɫ  ͸����}
 */
export const hexToRGBA = (_color, _opacity) => {
  var sColor = _color.toLowerCase()
  // ʮ��������ɫֵ���������ʽ
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  // �����16������ɫ
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (var i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    // ������λ����ɫֵ
    var sColorChange = []
    for (var j = 1; j < 7; j += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(j, j + 2)))
    }
    return 'rgba(' + sColorChange.join(',') + ',' + _opacity + ')'
  }
  return sColor
}
